// @agentx/sdk — Configuration module
export { ConfigurationRegistry, KNOWN_CHAINS } from './config'
export type { ConfigRegistryOpts, ChainConfig } from './config'
export const CONFIG_VERSION = '0.1.0'
